import React from 'react'

const LeftArrowIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12"><path d="M5.429 19.76a.824.824 0 0 0 .571.24.8.8 0 0 0 .574-.24l5.183-5.145a.8.8 0 0 0 0-1.145.817.817 0 0 0-1.154 0l-3.784 3.765v-16.425a.816.816 0 0 0-1.631 0v16.425l-3.794-3.766a.817.817 0 0 0-1.154 0 .8.8 0 0 0 0 1.145z" transform="translate(20) rotate(90)" fill={props.fill} /></svg>
)

export default LeftArrowIcon